var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSbmCitizenFeedbackCitizensGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1067.67 889.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#01324f;}.cls-2,.cls-3,.cls-4{fill:none;}.cls-5{fill:#f8ba8c;}.cls-6,.cls-7{mix-blend-mode:multiply;}.cls-6,.cls-8{fill:#e8e8e8;}.cls-9{fill:#2b7779;}.cls-10{fill:#004b74;}.cls-11{fill:#da9c73;}.cls-12{fill:#389496;}.cls-13{fill:#e09d73;}.cls-14{fill:#a71916;}.cls-15{isolation:isolate;}.cls-16{fill:#b31f1c;}.cls-17{fill:#422918;}.cls-18{fill:#583636;}.cls-19{fill:#0280c3;}.cls-20{clip-path:url(#clippath-1);}.cls-21{clip-path:url(#clippath-2);}.cls-22{fill:#f39d86;}.cls-23,.cls-24{fill:#fff;}.cls-7{fill:#e7dbd6;}.cls-25{fill:#c21b1c;}.cls-26{fill:#45b9bc;}.cls-27{fill:#352e35;}.cls-28{fill:#005795;}.cls-24{mix-blend-mode:soft-light;opacity:.4;}.cls-29{fill:#bf0f2c;}.cls-30{fill:#e63a3a;}.cls-31{fill:#fcfcfc;}.cls-32{fill:#301b16;}.cls-33{fill:#432827;}.cls-3{stroke-width:5.7px;}.cls-3,.cls-4{stroke:#301b16;stroke-miterlimit:10;}.cls-4{stroke-width:6.18px;}.cls-34{fill:#c03a2a;}.cls-35{clip-path:url(#clippath);}.cls-36{fill:#ececec;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M799.37,267.23c0,147.59-119.64,267.23-267.23,267.23s-267.24-119.64-267.24-267.23S384.54,0,532.14,0s267.23,119.64,267.23,267.23Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,622.37c0-147.58,119.64-267.23,267.23-267.23s267.24,119.64,267.24,267.23-119.64,267.24-267.24,267.24S0,769.96,0,622.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M533.21,622.37c0-147.6,119.64-267.24,267.23-267.24s267.23,119.64,267.23,267.24-119.64,267.22-267.23,267.22-267.23-119.64-267.23-267.22Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_copy"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M799.37,267.23c0,147.59-119.64,267.23-267.23,267.23s-267.24-119.64-267.24-267.23S384.54,0,532.14,0s267.23,119.64,267.23,267.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M486.56,376.01h84.99v-31.4s-9-8.26-37.63-8.26-40.08,5.51-40.08,5.51l-7.28,34.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "458.48 442.1 604.42 442.1 617.64 370.86 555.95 357.64 555.95 317.08 506.94 317.08 506.94 357.64 445.26 370.86 458.48 442.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M506.94,325.34s11.01,16.52,25.33,16.52,23.68-16.52,23.68-16.52v-8.25h-49.02v8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M614.77,257.78c-8.36,26.44-46.67,74.17-81.49,74.17-31.35,0-72.44-39.65-82.19-74.17-9.75-34.52-6.27-74.17-6.27-74.17,0-47,13.93-97.67,88.46-97.67s88.45,58.75,88.45,104.28c0,0,1.38,41.12-6.96,67.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M422.8,237.06c4.71,15.53,20.92,23.71,24.52,15.59,3.51-7.9,10.69-12.25,8.49-25.43-2.2-13.18-19.17-27.4-26.53-23.42-11.49,6.23-10.34,20.52-6.47,33.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M640.31,235.42c-4.71,15.53-20.92,23.71-24.51,15.59-3.51-7.9-10.69-12.25-8.49-25.43,2.19-13.18,19.17-27.4,26.53-23.42,11.49,6.23,10.34,20.52,6.47,33.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M603.97,239.05c13.94-6.98,12.38-36.89,29.87-36.89,16.84-60.23-26.12-135.68-55.64-123.43-10.69-20.51-38.22-23.27-67.41-19.62-70.53,8.79-99.68,89.29-84.29,146.58,16.06-10.52,9.62,19.78,31.56,33.36-8.88-19.1,10.71-13.67,1.22-44.43,9.22-13.03,82.79-12.85,110.99-65.36,8.36,26.81,17.33,36.72,31.96,56.54,14.62,19.83,6.96,45.17,1.73,53.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M584.61,49.86c0,23.61-23.09,50.64-51.59,50.64s-51.59-27.03-51.59-50.64,23.1-34.85,51.59-34.85,51.59,11.24,51.59,34.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 458.48,
    y: 442.1,
    width: 145.94,
    height: 184.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M571.56,344.61l-32.66,167.25v69.76l82.92,60.22s-3.09-87.39-14.1-124.85c.74-17.62,12.69-70.46,12.69-70.46l3.1-75.67-33.76-7.24-18.2-19.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M566.06,341.49c4.59,20.93-27.15,170.37-27.15,170.37v69.76l34.31-104.27-10.65-11.02,14.69-12.85,12.5-89.85s-11.59-16.99-23.7-22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M662.07,433.28c2.62,12.39,14.45,170.43,13.21,226.91-3.38,6.63-28.4,15.81-32.26,10.76-5.38-76.11-22.6-211.45-22.6-224.42,0-17.18-14.08-75.67,3.1-75.67s29.75,20.57,38.55,62.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M488.34,344.99l32.66,167.24v69.76l-76.77,59.85s3.23-82.39,14.26-119.83c-.74-17.62-19-75.1-19-75.1l-3.1-75.68,33.76-7.24,18.19-19.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M493.84,341.86c-4.59,20.93,27.15,170.37,27.15,170.37v69.76l-34.31-104.28,10.64-11.01-14.68-12.85-12.5-89.85s11.59-16.99,23.7-22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M397.82,433.66c-2.6,12.39-14.43,170.43-13.21,226.9,3.39,6.63,28.41,15.81,32.27,10.76,5.38-76.12,22.6-211.44,22.6-224.41,0-17.19,14.08-75.68-3.1-75.68s-29.75,20.57-38.56,62.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M630.87,253.05c0,3.65-2.96,6.61-6.61,6.61s-6.62-2.97-6.62-6.61,2.97-6.62,6.62-6.62,6.61,2.96,6.61,6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M447.05,253.05c0,3.65-2.96,6.61-6.62,6.61s-6.61-2.97-6.61-6.61,2.96-6.62,6.61-6.62,6.62,2.96,6.62,6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M473.62,207.22s-.46-.31-1.14-.75c-.37-.29-.85-.85-1.25-1.35-.31-.53-.55-1.09-.75-1.65-.65-2.3-.29-4.49-.29-4.49,0,0,.35,2.24,1.48,3.94.29.39.64.76.92,1.04.36.18.51.36.81.5.79.23,1.32.38,1.32.38.7.2,1.11.94.9,1.64-.2.7-.94,1.11-1.64.9-.13-.04-.25-.1-.37-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M510.88,211.4c0,4.82-7.94,11.77-17.83,11.77-12.08,0-19.36-7.02-19.36-14.46s10.45-12.41,19.28-10.78c9.72,1.8,17.9,8.16,17.9,13.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M505.37,211.33c0,4.49-2.27,8.45-5.73,10.81-4.37,2.18-13.19.95-15.13-.32-3.22-2.38-5.27-6.19-5.27-10.48,0-7.22,5.85-13.08,13.06-13.08s13.07,5.85,13.07,13.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M473.9,210.84s-.23-.76-.37-2.16c-.09-1.42.17-3.61,1.64-5.72,1.45-2.11,3.91-3.94,6.82-5.07,2.92-1.12,6.24-1.64,9.63-1.45,1.77.15,3.23.57,4.83,1.05,1.56.48,3.03,1.07,4.42,1.74,2.79,1.3,5.08,3.13,6.79,4.89,1.75,1.75,2.69,3.68,3.07,5.06.35,1.41.11,2.22.16,2.21,0,0-.08-.82-.65-2.03-.56-1.23-1.86-2.68-3.6-4.14-1.74-1.49-4.15-2.72-6.73-3.91-1.3-.57-2.71-1.07-4.14-1.45-1.38-.4-3.02-.67-4.39-.86-5.86-.52-12.17,1.51-15.08,4.83-3.06,3.39-2.22,7.13-2.4,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M501.23,213.61c0,4.6-3.73,8.32-8.33,8.32s-8.34-3.72-8.34-8.32,3.73-8.33,8.34-8.33,8.33,3.73,8.33,8.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 498.49,
    cy: 209.75,
    r: 3.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 496,
    cy: 204.05,
    r: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M594.76,204.85s.53-.15,1.32-.38c.31-.14.45-.32.81-.5.29-.28.63-.65.92-1.04,1.13-1.7,1.49-3.94,1.49-3.94,0,0,.36,2.19-.3,4.49-.2.56-.44,1.12-.74,1.65-.41.5-.88,1.05-1.25,1.35-.69.44-1.15.75-1.15.75-.61.4-1.43.23-1.84-.37-.41-.61-.24-1.43.37-1.84.11-.07.25-.13.37-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M558.58,211.4c0,4.82,7.94,11.77,17.83,11.77,12.1,0,19.37-7.02,19.37-14.46s-10.46-12.41-19.28-10.78c-9.73,1.8-17.92,8.16-17.92,13.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M564.12,211.33c0,4.49,2.27,8.45,5.72,10.81,4.37,2.18,13.2.95,15.15-.32,3.19-2.38,5.26-6.19,5.26-10.48,0-7.22-5.84-13.08-13.07-13.08s-13.06,5.85-13.06,13.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M595.59,210.84c-.18.13.64-3.61-2.41-7-2.91-3.32-9.23-5.35-15.09-4.83-1.37.19-3,.47-4.39.86-1.42.38-2.83.88-4.14,1.45-2.59,1.19-4.99,2.41-6.73,3.91-1.73,1.46-3.05,2.9-3.6,4.14-.57,1.21-.66,2.03-.66,2.03.05.01-.18-.8.17-2.21.37-1.38,1.31-3.32,3.06-5.06,1.72-1.76,4-3.59,6.8-4.89,1.39-.67,2.85-1.26,4.42-1.74,1.6-.48,3.05-.9,4.84-1.05,3.38-.19,6.7.33,9.63,1.45,2.92,1.12,5.37,2.95,6.82,5.06,1.47,2.11,1.73,4.3,1.64,5.72-.14,1.4-.36,2.16-.36,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M568.25,213.61c0,4.6,3.74,8.32,8.34,8.32s8.32-3.72,8.32-8.32-3.72-8.33-8.32-8.33-8.34,3.73-8.34,8.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M574.71,209.75c0,2.06-1.68,3.72-3.72,3.72s-3.71-1.66-3.71-3.72,1.66-3.72,3.71-3.72,3.72,1.67,3.72,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M572.26,204.05c0,.68.55,1.23,1.22,1.23s1.23-.55,1.23-1.23-.55-1.23-1.23-1.23-1.22.55-1.22,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M539.11,249.49s-2.53,4.29-8.04,4.29-9.17-1.64-9.97-2.55c-.81-.91,5.43-11.94,5.43-11.94,0,0-2.92,7.71-1.6,9.61,1.33,1.91,4.9,1.87,6.61,1.87,5.51,0,7.59-1.28,7.59-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M558.42,277.02c0,12.63-11.37,22.86-25.4,22.86s-25.39-10.23-25.39-22.86h50.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M513.17,291.25c4.65,5.25,11.82,8.63,19.85,8.63s15.21-3.38,19.86-8.63c0,0-8.73-2.8-19.86-2.8s-19.85,2.8-19.85,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M554.82,282.84c.48-1.85.75-3.81.75-5.83h-45.09c0,1.92.23,3.77.67,5.55.25,1.03,2.11,2.99,4,2.99h36.07c2.06,0,3.35-1.79,3.6-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M599.34,183.94s-13.88-6.47-27.81-5.16c-5.44.51-11.1,1.08-13.24,1.52-2.13.44-1.3-5.75.13-6,1.42-.25,7.62-3.68,13.63-3.27,15.4,1.05,27.29,12.92,27.29,12.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M471.72,183.94s13.88-6.47,27.81-5.16c5.44.51,11.1,1.08,13.23,1.52,2.15.44,1.31-5.75-.11-6-1.42-.25-7.63-3.68-13.63-3.27-15.41,1.05-27.29,12.92-27.29,12.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M592.22,236.84c0,4.97-7.84,9-17.51,9s-17.51-4.03-17.51-9,7.84-9,17.51-9,17.51,4.03,17.51,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M507.2,236.84c0,4.97-7.84,9-17.51,9s-17.51-4.03-17.51-9,7.84-9,17.51-9,17.51,4.03,17.51,9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M0,622.37c0-147.58,119.64-267.23,267.23-267.23s267.24,119.64,267.24,267.23-119.64,267.24-267.24,267.24S0,769.96,0,622.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M340.7,647.98c-29.53,35.06-66.96,46.68-81.61,46.63-14.99-.06-55.46-10.53-85.53-47.29-17.04-20.83-23.95-61.72-28.34-90.27-2.53-16.4-9.38-69.83,2.19-87.25,8.28-12.47,19.83-23.23,35.3-31.23,1.93-1-15.45-11.07-13.41-11.98.83-.38,19.63,4.76,18.63,0-1.59-7.45-4.24-16.75-4.24-16.75,0,0,9.47,13.77,24.64,13.73,15.62-.04,30.25-.07,47.48,0,21.33.08,51.36-.51,54.88,13.69,28.84-.89,43.38,14.12,50.46,26.98,10.32,18.74,14.07,44.94,11.31,69.85-3.65,32.9-14.03,92.85-31.75,113.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M164.61,580.8s3.61-27.22-20.04-20.67c-18.21,5.06.27,55.64,12.24,60,10.23,3.74,12.49-4.11,12.49-4.11l-4.69-35.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M351.05,581.53s-3.39-27.25,20.2-20.5c18.17,5.2-.71,55.62-12.71,59.89-10.27,3.67-12.45-4.19-12.45-4.19l4.96-35.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M393.14,889.6l13.52-139.14s-49.36-21.87-77.75-28.8c-26.72-6.54-58.06-5.94-61.33-5.86-3.27-.11-34.6-.94-61.36,5.36-28.44,6.7-77.15,28.2-77.15,28.2,0,0,10.56,65.05,20.75,140.23h243.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M258.87,766.98s66.45-44.97,62.49-47.17c-23.04-12.77-21.51-48.29-21.51-48.29l-83.53-4.7s5.08,51.07-19.68,57.29c-1.82.46,62.24,42.87,62.24,42.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M215.07,697.32c3.47,1.18,6.89,3.04,10.14,5.83,10.98,9.4,36.47,23.5,51.78,18.77,11.32-3.51,19.72-13.39,27.66-22.48-5.39-13.69-4.8-27.92-4.8-27.92l-83.53-4.7s1.54,15.53-1.25,30.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M353.4,593.84c-4.12,29.87-5.39,47.13-22.77,68.19-12.08,14.64-38.42,36.73-57.73,45.7-5.41,2.52-22.82,2.8-28.27.68-21.07-8.14-50.71-29.7-61.04-46.97-13.74-22.94-17.41-41.22-21.39-68.35-4.78-32.6-5.21-21.11-5.08-51.85.25-62.62,24.59-107.74,94.79-107.46,70.25.27,105.92,39.77,106.73,104.04.44,35.23-.72,23.28-5.25,56.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M184.4,548.87c9.47-9.77,24.33-7.23,37.53-7.58,12.43-.32,39.87-4.65,49.09-15.29,8.17-9.45,23.13-23.18,36.54-23.15,31.12.13,36.18,58.07,40.99,83.1,1.3,6.72,2.92,2.01,4.71,8.95.05-.36.1-.7.14-1.05,4.52-32.74,5.69-20.79,5.25-56.02-.81-64.27-34.47-108.04-104.73-108.31-70.2-.27-96.54,49.11-96.8,111.73-.11,29.33,8.21,20.16,12.4,47.53,6.05-12.66,3.69-28.35,14.87-39.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M178.33,544.84c23.34-17.47,90.72-2.25,120.84-53.89,35.69.59,41.28,39.97,46.92,52.82,2.62,5.94,2.52,55.04,2.52,55.04,0,0,4.71-4.39,4.79-4.98,4.52-32.74,9.67-19.92,9.23-55.15-.81-64.27-38.45-108.91-108.7-109.19-70.2-.27-100.03,49.07-100.27,111.68-.13,30.75,3.77,19.29,8.55,51.9.08.5,7.09-2.16,7.09-2.16,0,0,4.35-42.58,9.03-46.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M130.49,889.6l12.55-37.57s34.47-116.98-13.99-102.67c-30.25,8.94-50.58,81.11-62.3,140.23h63.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M406.01,889.6h63.8c-11.31-58.91-30.99-130.04-60.89-139.13-48.36-14.69-14.8,102.55-14.8,102.55l11.89,36.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M328.74,581.08s-.94,5.22-5.67,9.66c-3.56,3.34-25.2,5.5-27.48,4.47-3.41-1.54-7.81-8.87-7.81-8.87,0,0,7.66-10.44,17.07-10.4,9.38.04,23.9,5.14,23.9,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M304.83,578c6.79.03,16.24,2.69,20.95,4.17,1.08.34.51,4.05-1.31,7.12,3.88-3.53,4.27-8.2,4.27-8.2,0,0-14.52-5.1-23.9-5.14-9.4-.04-17.07,10.4-17.07,10.4,0,0,.3,1.04,1.09,1.69,1.68-2.1,7.81-10.07,15.96-10.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M315.17,585.51c-.03,5.26-4.31,9.51-9.58,9.49-5.26-.01-9.5-4.29-9.48-9.56.01-5.26,4.29-9.52,9.55-9.49,5.27.03,9.52,4.31,9.5,9.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M313.8,585.51c-.01,4.04-11.3-7.34-7.27-7.32,4.03.01,7.28,3.3,7.27,7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M178.33,564.6s5.39-3.42,17.39-7.1c13.08-4,30.9,2.28,31.6,2.29,1.22,0,3.01-.32,3.04-3.51,0-3.2-.97-5.79-2.19-5.8-.67,0-18.36-4.26-31.64-.37-10.17,2.97-18.21,14.48-18.21,14.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M339.15,565.24s-5.29-3.47-17.1-7.24c-12.86-4.1-30.5,2.04-31.18,2.04-1.21-.01-2.97-.34-2.97-3.52.03-3.2,1-5.79,2.2-5.79.69,0,18.15-4.11,31.22-.13,10,3.06,17.84,14.64,17.84,14.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M189.33,580.52s.9,5.23,5.59,9.7c3.53,3.37,25.16,5.7,27.45,4.7,3.42-1.52,7.88-8.81,7.88-8.81,0,0-7.57-10.51-16.96-10.55-9.4-.04-23.95,4.96-23.95,4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M213.26,577.63c-6.79-.03-16.25,2.55-20.99,4-1.08.32-.53,4.03,1.27,7.13-3.86-3.58-4.22-8.24-4.22-8.24,0,0,14.55-4.99,23.95-4.96,9.39.04,16.96,10.55,16.96,10.55,0,0-.31,1.03-1.09,1.67-1.68-2.11-7.74-10.12-15.88-10.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M202.87,585.05c-.03,5.27,4.22,9.56,9.49,9.58,5.26.01,9.54-4.23,9.57-9.5.01-5.25-4.23-9.55-9.49-9.56-5.27-.02-9.56,4.22-9.57,9.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M204.23,585.08c-.03,4.03,11.36-7.27,7.33-7.28-4.04,0-7.32,3.25-7.33,7.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "257.81 625.53 249.3 618.73 257.93 598.82 257.81 625.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "236.45 658.94 230.13 653.22 240.7 655.97 277.46 655.71 287.77 652.46 279.78 658.95 236.45 658.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M404.24,889.6h69.07c-11.64-59.31-33.93-132.11-64.26-141.2-48.41-14.51-14.4,102.6-14.4,102.6,0,0,4.96,20,9.58,38.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M454.94,889.6h18.37c-10.17-51.76-28.42-113.79-53.09-134.8,14.75,25.25,25.43,54.38,31.41,82.53,3.85,18.07,4.28,35.18,3.3,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M404.24,889.6h19.05c-9.77-13.86-17.06-36.14-24.16-68.06-.06-.3-9.12,10.13-9.36,9.92,2.57,11.53,4.89,19.54,4.89,19.54,0,0,4.96,20,9.58,38.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M134.31,889.6l9.28-38.6s34.03-117.12-14.4-102.6c-30.37,9.1-55.95,81.88-68.04,141.2h73.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.31,889.6l9.28-38.6s2.05-7.03,4.41-17.42c-11.44,13.32-21.8,40.69-29.03,49.26-2.05,2.45-4.19,4.65-6.37,6.75h21.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M203.79,741.52s13.2,11.48,59.06,11.48,59.06-11.48,59.06-11.48v71.36h-118.12v-71.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M393.63,889.6l13.16-141.2s-53.55-26.23-84.09-29.85c-25.2,61.39-62.07,86.72-62.07,86.72,0,0-39.53-37.86-60.9-84.54-28.4,6.82-70.55,27.66-70.55,27.66,0,0,9.75,65.63,19.2,141.2h245.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M134.12,782.57c2.24,15.93,5.07,36.46,8.14,59.49l25.93-30.22-34.08-29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M218.22,753.57c-6.7-10.1-13.16-21.19-18.49-32.83-7.1,1.72-15.06,4.29-23,7.19l36.56,31.38,4.93-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M129.19,748.4s.13.81.33,2.22l3.52-4.09c-2.44,1.16-3.85,1.86-3.85,1.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "258.78 889.6 220.71 856.93 192.67 889.6 258.78 889.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M337.06,721.39c-5.1-1.31-9.97-2.33-14.36-2.84-4.7,11.43-9.8,21.61-14.98,30.61l3.16,2.73,26.17-30.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "393.63 889.6 395.89 865.4 375.11 889.6 393.63 889.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M399.39,827.85l7.41-79.45s-.5-.24-1.19-.58l-42.2,49.14,35.98,30.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M168.19,811.84l52.52,45.09,45.1-52.52-1.91-1.63c-2.05,1.66-3.27,2.5-3.27,2.5,0,0-9.58-9.2-21.83-24.05l-25.51-21.92-45.09,52.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "363.4 796.97 310.89 751.9 265.81 804.41 318.32 849.5 363.4 796.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "365.04 889.6 318.32 849.5 283.89 889.6 365.04 889.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M363.4,796.97l42.2-49.14c-6.49-3.12-41.03-19.39-68.54-26.43l-26.17,30.5,52.52,45.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M238.8,781.23c-6.45-7.82-13.63-17.19-20.58-27.66l-4.93,5.74,25.51,21.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M310.89,751.9l-3.16-2.73c-17.73,30.74-36.45,47.67-43.82,53.61l1.91,1.63,45.08-52.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "375.11 889.6 395.89 865.4 399.39 827.85 363.4 796.97 318.32 849.5 365.04 889.6 375.11 889.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M213.29,759.31l-36.56-31.38c-18.09,6.64-36.06,14.97-43.7,18.61l-3.52,4.09c.67,4.54,2.33,15.9,4.6,31.94l34.08,29.27,45.09-52.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "283.89 889.6 318.32 849.5 265.81 804.41 220.71 856.93 258.78 889.6 283.89 889.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M152.53,889.6h40.14l28.04-32.67-52.52-45.09-25.93,30.22c1.82,13.79,3.72,28.44,5.63,43.56l4.64,3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M165.76,889.6c-1.73-5.76-3.6-11.48-5.81-17.14-5.07-12.92-12.15-24.74-18.56-36.94,2.25,16.81,4.62,35.15,7,54.09h17.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M286.06,734.12l26.02-36.18,10.62,20.61s-15.64,62.03-62.07,86.72c24.1-21.37,25.43-71.16,25.43-71.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M312.08,697.94l-.46.65c.66,67.74-47.04,103.18-50.99,106.68,46.43-24.69,62.07-86.72,62.07-86.72l-10.62-20.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M237.79,734.12l-31.18-36.18-6.87,22.8s14.49,59.85,60.9,84.54c-24.09-21.37-22.85-71.16-22.85-71.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M228.72,763.54c-9.96-17.92-15.98-37.66-23.68-56.59-.24-.6-.42-1.21-.6-1.82l-4.7,15.6s14.49,59.85,60.9,84.54c-5.53-4.91-9.68-11.36-12.87-18.33-7.43-6.55-13.91-14.2-19.05-23.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.49,612.7c-8.54,6.7-35.13,7.06-45.59,0-10.44-7.08-22.8-34.4-11.87-43.54,10.92-9.14,57.46-8.91,65.06,0,7.6,8.91.95,36.82-7.6,43.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M281.23,612.7c8.55,6.7,35.15,7.06,45.59,0,10.46-7.08,22.8-34.4,11.88-43.54-10.93-9.14-57.47-8.91-65.07,0-7.6,8.91-.95,36.82,7.6,43.54Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 249.41,
    y1: 577.54,
    x2: 270.32,
    y2: 577.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M533.21,622.37c0-147.6,119.64-267.24,267.23-267.24s267.23,119.64,267.23,267.24-119.64,267.22-267.23,267.22-267.23-119.64-267.23-267.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M882.22,652.56c-32.04,38.05-72.64,50.66-88.54,50.59-16.25-.07-60.17-11.43-92.78-51.3-18.49-22.58-25.98-66.96-30.74-97.92-2.73-17.8-5.1-73.23,2.37-94.63-22.22-25.48-11.37-49.44-11.37-49.44,0,0,9.17,23.52,64.73,10.34,16.47-3.91,45.81-7.88,64.22-11.06,27.1-4.68,55.72-.55,59.54,14.86,31.28-.98,47.06,15.32,54.74,29.26,11.18,20.31,15.26,48.75,12.26,75.77-3.96,35.69-15.22,100.72-34.45,123.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M691.21,579.69s3.91-29.54-21.75-22.42c-19.74,5.48.3,60.35,13.28,65.08,11.09,4.07,13.54-4.44,13.54-4.44l-5.07-38.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M893.47,580.49s-3.68-29.57,21.91-22.26c19.71,5.65-.77,60.35-13.79,64.97-11.13,3.98-13.51-4.54-13.51-4.54l5.39-38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M936,913.55l14.56-149.8s-53.56-23.74-84.35-31.25c-28.99-7.08-62.98-6.44-66.53-6.35-3.55-.12-37.53-1.03-66.57,5.83-30.84,7.27-83.7,30.58-83.7,30.58,0,0,10.1,69.94,19.94,150.99h266.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M793.44,781.66s70.77-48.18,66.48-50.56c-24.98-13.84-22.01-53.01-22.01-53.01l-90.62-5.09s5.51,55.4-21.35,62.15c-1.98.5,67.5,46.51,67.5,46.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M745.94,706.12c3.76,1.25,7.48,3.28,11,6.3,11.91,10.2,39.57,25.49,56.16,20.36,12.29-3.8,20.76-13.31,29.38-23.17-5.85-14.85-4.57-31.51-4.57-31.51l-90.62-5.09s1.65,16.85-1.35,33.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M896.01,593.84c-4.47,32.4-5.85,51.12-24.7,73.97-13.11,15.88-41.71,39.83-62.64,49.57-5.88,2.73-24.74,3.04-30.66.75-22.87-8.84-55.02-32.24-66.22-50.95-14.91-24.89-18.89-44.73-23.2-74.16-5.19-35.37-5.65-22.9-5.52-56.25.26-67.92,26.68-116.87,102.82-116.58,76.22.31,114.92,43.14,115.8,112.87.48,38.21-.78,25.26-5.69,60.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M742.58,659.47c-4.94,16.62,4.36,41.58,7.54,43.7,9.55,6.35,19.37,11.67,27.9,14.96,5.92,2.29,24.78,1.98,30.66-.75,6.54-3.04,13.82-7.47,21.16-12.6,3.54-2.49,14.28-29.08,12.44-45.3-1.85-16.23-29.28-22.8-50.92-22.41-21.65.38-43.83,5.79-48.77,22.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M750.77,660.96c-3.18,10.71,12.12,32.03,14.17,33.39,6.15,4.09,12.49,7.52,17.98,9.65,1.67.64,6.04-21.73,9.52-21.73,4.45.02,8.12,22.22,10.25,21.24,4.21-1.96,8.91-4.82,13.62-8.13,2.29-1.59,18.72-27.47,17.53-37.94-1.19-10.46-22.8-1.82-44.04-1.82-13.95,0-35.85-5.37-39.03,5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M721.41,511.81c10.27-10.59,88.28,28.44,103.39,26.33,22.1-3.09,22.05-21.69,36.62-21.64,33.74.13,24.1,41.63,29.31,68.77,1.4,7.29,3.16,2.17,5.12,9.7.05-.39.1-.75.15-1.14,4.91-35.52,6.18-22.57,5.69-60.78-.88-69.72-37.41-117.19-113.62-117.5-76.14-.3-104.74,53.28-105,121.21-.12,31.81,8.9,21.87,13.44,51.55,6.57-13.72,12.76-63.98,24.89-76.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M713.68,501.83c22.37-22.38,102.26,61.6,134.94,5.58,38.7.65,33.32,18.2,39.45,32.12,2.83,6.45,2.74,59.71,2.74,59.71,0,0,5.1-4.76,5.19-5.4,4.91-35.52,10.48-21.61,10.01-59.82-.88-69.72-41.72-118.15-117.94-118.46-76.14-.3-108.5,53.24-108.77,121.17-.13,33.36,4.1,20.92,9.29,56.29.08.55,7.67-2.35,7.67-2.35,0,0-11.19-60.26,17.41-88.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M651.35,913.55l13.25-39.63s37.4-126.89-15.18-111.36c-32.62,9.63-54.61,87.06-67.36,150.99h69.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M949.49,913.55h69.35c-12.29-63.67-33.58-140.01-65.83-149.8-52.45-15.94-16.06,111.25-16.06,111.25l12.54,38.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M869.25,579.99s-1.02,5.66-6.14,10.47c-3.86,3.62-27.34,5.98-29.82,4.86-3.68-1.67-8.48-9.63-8.48-9.63,0,0,8.31-11.32,18.51-11.29,10.18.04,25.92,5.58,25.92,5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M843.3,576.64c7.37.03,17.62,2.92,22.73,4.52,1.17.37.56,4.4-1.42,7.73,4.21-3.84,4.64-8.9,4.64-8.9,0,0-15.74-5.54-25.92-5.58-10.2-.03-18.51,11.29-18.51,11.29,0,0,.32,1.13,1.18,1.83,1.83-2.27,8.49-10.92,17.31-10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M854.52,584.8c-.03,5.7-4.67,10.32-10.37,10.29-5.71-.03-10.32-4.66-10.3-10.38.02-5.71,4.66-10.32,10.38-10.29,5.71.02,10.32,4.66,10.29,10.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M853.03,584.81c-.01,4.36-12.26-7.97-7.88-7.96,4.37.03,7.9,3.58,7.88,7.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M706.08,562.13s5.85-3.72,18.87-7.71c14.18-4.33,33.53,2.48,34.28,2.49,1.32,0,3.28-.34,3.29-3.8.01-3.48-1.04-6.29-2.36-6.3-.74,0-19.92-4.62-34.33-.41-11.02,3.22-19.75,15.72-19.75,15.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M880.53,562.81s-5.73-3.77-18.54-7.85c-13.95-4.46-33.1,2.21-33.84,2.21-1.3-.01-3.22-.37-3.21-3.83.01-3.47,1.08-6.28,2.39-6.27.72,0,19.67-4.46,33.85-.13,10.85,3.31,19.35,15.87,19.35,15.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M718.02,579.39s.97,5.67,6.05,10.53c3.83,3.65,27.29,6.18,29.77,5.08,3.71-1.65,8.56-9.56,8.56-9.56,0,0-8.21-11.39-18.41-11.42-10.18-.05-25.97,5.37-25.97,5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M743.98,576.25c-7.37-.03-17.64,2.78-22.76,4.34-1.18.36-.58,4.39,1.36,7.73-4.18-3.86-4.56-8.93-4.56-8.93,0,0,15.79-5.42,25.97-5.37,10.2.03,18.41,11.42,18.41,11.42,0,0-.34,1.12-1.2,1.82-1.8-2.29-8.39-10.98-17.22-11.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M732.7,584.31c-.03,5.71,4.59,10.36,10.29,10.39,5.71.02,10.36-4.59,10.38-10.31.03-5.7-4.59-10.35-10.3-10.37-5.71-.02-10.36,4.59-10.38,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M734.18,584.33c-.02,4.37,12.32-7.87,7.94-7.88-4.37-.02-7.93,3.51-7.94,7.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "792.31 628.22 783.07 620.84 792.42 599.24 792.31 628.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "768.26 667.98 761.41 661.78 772.87 664.76 812.75 664.47 823.94 660.96 815.27 667.99 768.26 667.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M770.47,612.81c-9.27,7.27-38.12,7.67-49.45,0-11.33-7.67-24.73-37.32-12.88-47.23,11.85-9.9,62.34-9.66,70.58,0,8.25,9.68,1.03,39.96-8.25,47.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M816.84,612.81c9.28,7.27,38.13,7.67,49.46,0,11.33-7.67,24.73-37.32,12.88-47.23-11.85-9.9-62.34-9.66-70.58,0-8.25,9.68-1.03,39.96,8.24,47.23Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 782.32,
    y1: 574.67,
    x2: 804.99,
    y2: 574.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M936,913.55l14.56-149.8s-53.56-23.74-84.35-31.25c-1.96,41.34-38.53,64.52-70.47,64.52s-65.01-27.38-64.78-66.16c-30.84,7.27-81.55,31.7-81.55,31.7,0,0,10.1,69.94,19.94,150.99h266.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M936,913.55l5.13-52.78c-.23.12-.47.22-.71.33-22.29,12.2-20.75,30.62-21.63,52.45h17.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M679.88,913.55c-7.89-26.9-14.36-48.52-17.38-54.54,2.21,17.05,4.53,35.51,6.85,54.54h10.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M651.35,913.55l13.25-39.63s37.4-126.89-15.18-111.36c-32.62,9.63-54.61,87.06-67.36,150.99h69.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M651.35,913.55l13.25-39.63s5.58-19.01,9.4-41.4c-14,21.94-33.56,37.97-39.75,65.6-1.17,5.18-2.54,10.32-3.98,15.43h21.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M949.49,913.55h69.35c-12.29-63.67-33.58-140.01-65.83-149.8-52.45-15.94-16.06,111.25-16.06,111.25l12.54,38.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M949.49,913.55h24.85c-1.7-6.84-3.58-13.58-5.74-20.14-6.84-20.67-22.52-30.81-37.75-43.77,3.06,14.71,6.1,25.37,6.1,25.37l12.54,38.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M857.1,727.33s-11.31,57.53-61.24,56.18c-50.11-1.35-56.99-59.69-56.99-59.69l-7.9,7.05s-4.05,73.87,65.88,72.34c69.93-1.54,69.38-70.7,69.38-70.7l-9.11-5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M751.17,913.55v-40.28c-19.07-66.47-20.32-123.09-20.21-142.41-30.84,7.27-81.55,31.7-81.55,31.7,0,0,7.25,67.64,13.48,150.99h88.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M938.35,913.55c5.74-83.27,12.21-149.8,12.21-149.8,0,0-53.56-23.74-84.35-31.25-.91,19.22-2.73,83.59-21.28,140.24l.48,40.81h92.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M938.35,913.55c1.17-16.91,2.36-33.15,3.53-48.26-.39.64-.76,1.29-1.21,1.94-9.4,13.58-16.06,29.46-20.79,46.31h18.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M861.99,913.55l16.17-42.86-20.87-6.7,36.58-9.27,17.52-110.77-45.18-11.46s-2.05,75.36-21.28,140.24c.13,10.99.31,26.3.47,40.81h16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M739.85,862.36l-20.86,6.7,16.79,44.5h15.95c.17-14.99.36-31.05.48-42.45-19.23-64.88-21.28-140.24-21.28-140.24l-45.17,11.47,17.52,110.76,36.58,9.27Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbmCitizenFeedbackCitizensGraphic);
export default __webpack_public_path__ + "static/media/SBM-CITIZEN-FEEDBACKCitizens-Graphic.e4859762b61e10b857cef6d5a3563194.svg";
export { ForwardRef as ReactComponent };